import {PanelDashed} from "../../../../../components/PanelDashed";
import {ValuableItem} from "@falcon/services";
import {NavigateFunction} from "react-router-dom";

interface IProps {
    interactionId: string
    items: ValuableItem[]
    navigate: NavigateFunction
}

export function AddItemPanel(props: IProps) {

    const startJourney = () => {
        window.sessionStorage.removeItem("existingItemIds");
        window.sessionStorage.setItem("existingItemIds", JSON.stringify(props.items.map((item: ValuableItem) => item.valuableItemId)));
        props.navigate(`/journey/show/product/RentersInsurance/process/mtaAddItem/preset/${props.interactionId}`);
    };

    return (
        <PanelDashed>
            <div className="panel-dashed-title">Add items</div>
            <div className="panel-dashed-contents mx-md-n1">You can add <b>10 items</b> worth <b>up to £5,000 each</b> or up to £20,000 in total</div>
            <div className="panel-dashed-links">
                <div id="addItem" className="btn btn-white-dashboard m-auto w-50" onClick={startJourney}>
                    Add item(s)
                </div>
            </div>
        </PanelDashed>
    );
}
